import React, { useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import axios from 'axios';
import { API_URL } from '../../../common/Constants';
import Cookies from '../../../common/Cookies';

/**
 * Button that opens Stripe Customer Portal for managing subscription, payment methods,
 * and customer billing details stored on the Stripe customer.
 */
const StripePortalButton = ({
  onError,
  label = 'Manage Payment',
  startIcon = null,
  variant = 'outlined',
  color = 'primary',
  size = 'medium',
  sx
}) => {
  const [loading, setLoading] = useState(false);

  const handleClick = () => {
    setLoading(true);
    axios
      .post(
        `${API_URL}/payment/create-portal-session`,
        { return_url: window.location.href },
        {
          headers: {
            Authorization: `Bearer ${Cookies.getJwtToken() || localStorage.getItem('token') || 'dummy-token'}`
          }
        }
      )
      .then((res) => {
        if (res.data.success && res.data.url) {
          window.location.href = res.data.url;
        } else {
          onError?.(res.data.message || 'Failed to open billing portal');
          setLoading(false);
        }
      })
      .catch((err) => {
        onError?.(err.response?.data?.message || err.message || 'Error opening billing portal');
        setLoading(false);
      });
  };

  return (
    <Button
      variant={variant}
      color={color}
      size={size}
      onClick={handleClick}
      disabled={loading}
      startIcon={loading ? <CircularProgress size={size === 'small' ? 14 : 16} /> : startIcon}
      sx={sx}
    >
      {loading ? 'Opening...' : label}
    </Button>
  );
};

export default StripePortalButton;
